/*
 * 企業側 案件詳細
 */
import { apiGetOne } from '@/actions/ApiBaseActions';
export const API_GET_ONE_CLIENT_RFP_COUNT = 'API_GET_ONE_CLIENT_RFP_COUNT';
export const API_GET_ONE_CLIENT_RFP_COUNT_SUCCESS = 'API_GET_ONE_CLIENT_RFP_COUNT_SUCCESS';
/**
 * 案件の各件数の取得
 */
export const apiGetOneClientRfpCount = (_args, meta) => apiGetOne(API_GET_ONE_CLIENT_RFP_COUNT, `/client/rfp_count`, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
